(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxAssignGoProfileToMany(
    NetworkListPaging, PrinterListPOSTPaging, PrinterListService, PrinterVendorListPaging, 
    PrinterVendorService, $http, toastr, $filter, EnumerationService
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      templateUrl: 'app/components/settings/printixGo/assignGoProfileToMany/assignGoProfileToMany.template.html',
      link: function(scope) {

        scope.useTheseFilter = {
          accepted: false
        };
        scope.resultIsValid = false;
        scope.selectedNetworks = [];

        (function(){
          getPrintersCount();
        })();

        function getPrintersCount () {
          var printerListPaging = new PrinterListPOSTPaging();
          printerListPaging.pagingCriteria.pageSize = 1;
          printerListPaging.pagingCriteria.types = 'VIRTUAL,NETWORK';
          PrinterListService.getPrinterListPaged(printerListPaging).then(function(response) {
            scope.totalPrintersCount = response.page.totalElements;
          }).catch(function(error) {});
        }

        scope.showNetworkList = function () {
          var networkPaginationObject = new NetworkListPaging();
          scope.networkPaginationObject = networkPaginationObject;
        }

        scope.selectNetwork = function(network) {
          scope.networkPaginationObject = null;
          if (network) {
            if (checkIfNetworkIsAlreadySelected(network)) {
              scope.selectedNetworks.push(network);
              updateFilter();
            }
          }
        }

        function checkIfNetworkIsAlreadySelected (network) {
          for (var i = 0; i < scope.selectedNetworks.length; i++) {
            if (scope.selectedNetworks[i].info._links.self.href === network.info._links.self.href) {
              return false;
            }
          }
          return true;
        }

        scope.removeNetwork = function (event, network) {
          event.stopPropagation();
          for (var i = 0; i < scope.selectedNetworks.length; i++) {
            if (scope.selectedNetworks[i].info._links.self.href === network.info._links.self.href) {
              scope.selectedNetworks.splice(i, 1);
              updateFilter();;
            }
          }
        }

        function selectedNetworksToString() {
          var networksString = '';
          for (var i = 0; i < scope.selectedNetworks.length; i++) {
            networksString += scope.selectedNetworks[i].info._links.self.href + ',';
          }
          return networksString;
        }

        function updateFilter () {
          var printerListPaging = new PrinterListPOSTPaging();
          printerListPaging.pagingCriteria.pageSize = 1;
          printerListPaging.pagingCriteria.pageSize
          printerListPaging.pagingCriteria.networks = selectedNetworksToString()
          printerListPaging.pagingCriteria.types = 'VIRTUAL,NETWORK';
          PrinterListService.getPrinterListPaged(printerListPaging).then(function(response) {
            scope.targetedPrinters = response.page.totalElements;
            if (scope.targetedPrinters && scope.targetedPrinters !== scope.totalPrintersCount) {
              scope.resultIsValid = true; 
            } else {
              scope.resultIsValid = false; 
            }
          }).catch(function(error) {});
        }


        scope.assignGoProfileToPrinters = function () {
          var url = scope.tenant.info._links['px:printers'].href + '?networks=' + selectedNetworksToString()
          url = url + '&types=VIRTUAL,NETWORK';
          var body = [{
            path: '/printerCredential',
            op: 'replace',
            value: scope.context.context.info._links.self.href
          }]
          toastr.info($filter('translate')('WorkingOnIt'));
          $http.post(url, body, {headers: {"Content-Type": "application/json-patch+json"}}).then(function(response) {
            scope.updateParent()
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }

      }
    };
  }

  pxAssignGoProfileToMany.$inject = [
    'NetworkListPaging', 'PrinterListPOSTPaging', 'PrinterListService', 'PrinterVendorListPaging',
    'PrinterVendorService', '$http', 'toastr', '$filter', 'EnumerationService'
  ];

  angular
    .module('printix-admin')
    .directive('pxAssignGoProfileToMany', pxAssignGoProfileToMany);

})();
